import ThemeInterface from '../ThemeInterface';

const core = {
  brand: '#000',
  accent: '#b3a88e',
  foreground: '#333',
  neutral: '#efefef',
  border: '#8c8c8c',
  
  typography: {
    primary: 'Roboto, Helvetica, sans-serif',
    secondary: 'OldStandardTT, Helvetica, sans-serif',
  },
};

export default {
  core,
  header: {
    logoHeight: 36,
    width: '100%',
    mobileLogoHeight: 48,
    mobileMargin: 5,
  },
  sectionHeader: {
    fontFamily: core.typography.primary,
  },
  progressBar: {
    hideCounterBorder: true,
  },
  button: {
    lineHeight: 1.5,
    fontFamily: core.typography.primary,
    borderRadius: 1,
    letterSpacing: 0,
    primary: {
      backgroundColour: core.brand,
      colourOnHover: core.foreground,
      backgroundColourOnHover: core.accent,
      hasUnderlineOnHover: true,
    },
    secondary: {
      colour: core.foreground,
      borderColour: core.foreground,
      colourOnHover: core.foreground,
      backgroundColourOnHover: core.accent,
      borderColourOnHover: core.foreground,
      hasUnderlineOnHover: true,
    },
  },
  panel: {
    fontFamily: core.typography.primary,
    backgroundColour: core.accent,
    textColour: core.foreground,
  },
  surfaceHighlight: core.accent,
  selectedFieldHighlight: core.accent,
  deliveryOptions: {
    priceFontFamily: core.typography.primary,
  },
} as ThemeInterface;